import React from 'react';
import { useFees } from '../../context/FeeContext';

const PaymentSummary = ({ booking, userRole }) => {
  const { getBookingPricing } = useFees();

  // Unpaid bookings reflect the current live fee; paid bookings show their locked breakdown.
  const p = getBookingPricing(booking);
  const serviceAmount = p.serviceAmount;
  const fmt = (v) => Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  const rate = (v) => parseFloat(Number(v).toFixed(2)).toString();

  return (
    <div className="mt-4 p-4 bg-gray-50 rounded-lg border">
      <h5 className="font-semibold text-gray-700 mb-2">Payment Summary</h5>
      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-600">Service Amount:</span>
          <span>₱{fmt(serviceAmount)}</span>
        </div>
        {userRole === 'client' && (
          <div className="flex justify-between text-gray-600">
            <span>Platform Fee ({rate(p.clientFeeRate)}%):</span>
            <span>₱{fmt(p.clientFee)}</span>
          </div>
        )}
        {userRole === 'provider' && (
          <div className="flex justify-between text-gray-600">
            <span>Platform Fee ({rate(p.providerFeeRate)}%):</span>
            <span>-₱{fmt(p.providerFee)}</span>
          </div>
        )}
        <div className="flex justify-between font-bold text-lg pt-2 border-t border-gray-200">
          {userRole === 'client' ? (
            <>
              <span>Total to Pay:</span>
              <span className="text-orange-600">₱{fmt(p.clientTotal)}</span>
            </>
          ) : (
            <>
              <span>Your Earnings:</span>
              <span className="text-green-600">₱{fmt(p.providerPayout)}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentSummary;
